import { defineStore } from "pinia";

export const useWorkerStore = defineStore('worker', {
    state: () => ({
        worker: {},
        workers: [],
        workersSelect: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setWorker(worker) {
            this.worker = worker;
        },
        setWorkers(workers) {
            this.workers = workers;
        },
        setWorkersSelect(workersSelect) {
            this.workersSelect = workersSelect;
        },
        addWorker(worker) {
            this.workers.unshift(worker)
        },
        updateWorker(worker) {
            let index = this.workers.findIndex(cl => cl.id === worker.id)
            this.workers.splice(index, 1, worker)
        },
        deleteWorker(worker) {
            let index = this.workers.findIndex(cl => cl.id === worker.id)
            this.workers.splice(index, 1)
        },
    },
});